"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ErrorMessageComponentStyle_1 = require("./ErrorMessageComponentStyle");
var ErrorMsgComponent = function (props) {
    return (React.createElement(ErrorMessageComponentStyle_1.MessageContainer, null, props.showMessage && (React.createElement(ErrorMessageComponentStyle_1.PopUpText, { pass: props.pass }, props.message))));
};
exports.default = ErrorMsgComponent;
//# sourceMappingURL=ErrorMessageComponent.js.map